(function () {
  const STYLE_ID = 'cart-drawer-wallet-horizontal';
  let footerObserver;

  const SHADOW_CSS = `
    .wallet-cart-grid,
    .wallet-cart-grid:not(.wallet-cart-grid--horizontal) {
      flex-direction: row !important;
      flex-wrap: nowrap !important;
      gap: 0 !important;
      margin: 0 !important;
    }

    .wallet-cart-button-container {
      flex: 1 1 0 !important;
      min-width: 0 !important;
      width: auto !important;
      max-width: none !important;
    }

    @container wrapper (width <= 320px) {
      .wallet-cart-grid,
      .wallet-cart-grid:not(.wallet-cart-grid--horizontal) {
        flex-direction: row !important;
        flex-wrap: nowrap !important;
      }
    }
  `;

  function applyHorizontalLayout(host) {
    const shadow = host.shadowRoot;
    if (!shadow) {
      if (!host.dataset.cartDrawerCheckoutPending) {
        host.dataset.cartDrawerCheckoutPending = 'true';
        requestAnimationFrame(() => {
          delete host.dataset.cartDrawerCheckoutPending;
          applyHorizontalLayout(host);
        });
      }
      return;
    }

    shadow.querySelectorAll('.wallet-cart-grid').forEach((grid) => {
      grid.classList.add('wallet-cart-grid--horizontal');
    });

    if (shadow.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = SHADOW_CSS;
    shadow.appendChild(style);
  }

  function scan(root = document) {
    root.querySelectorAll('.cart-drawer__dynamic-checkout shopify-accelerated-checkout-cart').forEach(applyHorizontalLayout);
  }

  function observeFooter() {
    if (footerObserver) footerObserver.disconnect();

    const footer = document.querySelector('.cart-drawer__dynamic-checkout');
    if (!footer) return;

    footerObserver = new MutationObserver(() => scan());
    footerObserver.observe(footer, { childList: true, subtree: true });
  }

  function refresh() {
    scan();
    observeFooter();
  }

  function init() {
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.refreshCartDrawerAcceleratedCheckout = refresh;
})();
